import { useQuery } from '@tanstack/react-query';
import { identidadeQueries } from '../queries';

export function useIdentidade() {
  return useQuery(identidadeQueries.atual());
}
